import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconBra = props => {
  if (props.id !== "_svgiconbra") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><path d="M36.599 22.332c-.257-.734-.195-2.614-.135-4.135.07-1.8.683-3.374.689-3.39a.917.917 0 00-.532-1.192.937.937 0 00-1.208.525c-.03.076-.732 1.881-.814 3.985-.043 1.094.01 2.34.07 3.27a6.79 6.79 0 00-.604-.028c-1.28 0-3.249.35-5.35 2.017-2.286 1.812-3.046 4.091-3.276 5.143-.06.272-2.824.272-2.884 0-.23-1.052-.99-3.331-3.275-5.143-2.102-1.667-4.07-2.017-5.35-2.017a6.85 6.85 0 00-.605.027c.06-.93.113-2.175.07-3.269a13.538 13.538 0 00-.814-3.985.937.937 0 00-1.207-.525.917.917 0 00-.533 1.192c.006.016.618 1.59.689 3.39.06 1.522.122 3.401-.135 4.136-.66.822-1.44 2.499-1.393 5.823.025 1.781.697 3.238 1.945 4.211 1.043.815 2.476 1.264 4.033 1.264.572 0 1.146-.06 1.705-.179 2.244-.475 3.07-.928 4.122-1.663 1.482-1.035 2.898-1.035 4.38 0 1.051.735 1.878 1.188 4.122 1.663a8.207 8.207 0 001.705.179c1.558 0 2.99-.449 4.033-1.264 1.248-.973 1.92-2.43 1.945-4.211.046-3.325-.733-5.002-1.393-5.824" fill="#384048" fillRule="evenodd" /></svg>;
};

SvgIconBra.displayName = "_svgiconbra";
SvgIconBra.propTypes = {
  id: PropTypes.string
};
SvgIconBra.defaultProps = {
  id: ''
};
export default SvgIconBra;